<template>
  <v-app>
    <div
      v-if="$route.name === 'totem'"
      class="button-totem-adm"
      @click="openAdminModal"
    >
      <v-btn color="transparent"></v-btn>
    </div>
    <checkout-modal v-if="userToken && $route.name !== 'natal-luz'" />
    <natal-luz v-if="$route.name === 'natal-luz'" />
    <snack-bar />

    <error-dialog />

    <error-dialog-print v-if="$route.name === 'natal-luz' && dialogPrint" />

    <cart-expiration-dialog :expiration="expiration" />

    <reset-purchase v-if="showResetPurchase" />

    <reset-sector v-if="showResetSector" />

    <whatsapp-balloon />

    <half-circle-spinner
      v-if="loading"
      :animation-duration="1000"
      :size="60"
      color="#0067af"
    />
  </v-app>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';
import CartExpirationDialog from './components/UI/CartExpirationDialog';
import ResetPurchase from './components/Alerts/ResetPurchase';
import ResetSector from './components/Alerts/ResetSector';
import SnackBar from './components/UI/SnackBar';
import Modal from './components/Modal/Modal';
import ErrorDialog from './components/UI/ErrorDialog';
import ErrorDialogPrint from './components/UI/ErrorDialogPrint.vue';
import NatalLuz from './components/natal-luz/NatalLuz.vue';
import { mapGetters } from 'vuex';
import WhatsappBalloon from './components/shared/WhatsappBalloon.vue';

export default {
  name: 'App',
  components: {
    'checkout-modal': Modal,
    ErrorDialog,
    ResetSector,
    ResetPurchase,
    SnackBar,
    HalfCircleSpinner,
    CartExpirationDialog,
    NatalLuz,
    ErrorDialogPrint,
    WhatsappBalloon,
  },
  data() {
    return {
      numberClicks: 0,
      dialogPrint: false,
      alphabet: 'abcdefghijklmnopqrstuvwxyz',
    };
  },
  computed: {
    ...mapGetters(['screenTimeOn']),
    loading() {
      return this.$store.getters.loading;
    },
    expiration() {
      return this.$store.getters.body.expiration || 0;
    },
    userToken() {
      return this.$store.getters.userToken;
    },
    showResetPurchase() {
      return this.$store.getters.showResetPurchase;
    },
    showResetSector() {
      return this.$store.getters.showResetSector;
    },
  },
  created() {
    const uuidv1 = require('uuid/v1');
    let htSetted = null;
    if (
      window &&
      window.location &&
      window.location.search &&
      new URL(window.location).searchParams.get('ht')
    ) {
      this.$store.commit('SET_HT_BY_SITE');
      localStorage.setItem(
        'ht',
        new URL(window.location).searchParams.get('ht')
      );
      htSetted = localStorage.getItem('ht');
    }
    try {
      if (
        window &&
        window.localStorage &&
        !new URL(window.location).searchParams.get('ht')
      )
        htSetted = localStorage.getItem('ht');
    } catch (err) {
      if (err) {
        this.$store.dispatch('openSnackbar', {
          message:
            'Para prosseguir, habilite os cookies no seu navegador e atualize a página!',
          color: 'error',
        });
      }
    }

    if (new URL(window.location).searchParams.get('c'))
      this.$store.commit(
        'SET_CUPOM_CODE',
        new URL(window.location).searchParams.get('c')
      );
    if (new URL(window.location).searchParams.get('carrinho_abandonado'))
      this.$store.commit(
        'SET_CART_ABANDONED',
        new URL(window.location).searchParams.get('carrinho_abandonado')
      );
    if (
      new URL(window.location).searchParams.get('fbp') ||
      new URL(window.location).searchParams.get('fbc')
    )
      this.$store.commit('SET_FBC_FBP', {
        fbc: new URL(window.location).searchParams.get('fbc'),
        fbp: new URL(window.location).searchParams.get('fbp'),
      });

    if (htSetted) {
      if (!isNaN(htSetted.charAt(2))) {
        const increment = Number(htSetted.charAt(2)) + 3;
        if (
          (increment >= 10 && String(increment - 10) !== htSetted.charAt(7)) ||
          (increment < 10 && String(increment) !== htSetted.charAt(7))
        )
          htSetted = '';
      } else {
        const indexLetter = this.alphabet.indexOf(htSetted.charAt(2)) + 3;
        if (
          (indexLetter >= 26 &&
            this.alphabet.charAt(indexLetter - 26) !== htSetted.charAt(7)) ||
          (indexLetter < 26 &&
            this.alphabet.charAt(indexLetter) !== htSetted.charAt(7))
        )
          htSetted = '';
      }
    }
    if (!htSetted) {
      let ht = uuidv1();
      ht = ht.substring(0, 7);
      if (!isNaN(ht.charAt(2))) {
        let increment = Number(ht.charAt(2)) + 3;
        if (increment >= 10) ht += increment - 10;
        else ht += increment;
      } else {
        let indexLetter = this.alphabet.indexOf(ht.charAt(2)) + 3;
        if (indexLetter >= 26) {
          indexLetter = indexLetter - 26;
        }
        let increment = this.alphabet.charAt(indexLetter);
        ht += increment;
      }
      htSetted = ht;
      localStorage.setItem('ht', ht);
    }

    if (window.attachEvent)
      window.attachEvent('onload', this.riskField(htSetted));
    else window.addEventListener('load', this.riskField(htSetted), false);

    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname.includes('one-checkout') ||
      window.location.hostname.includes('192')
    ) {
      this.$store.commit('SET_API_URL', process.env.VUE_APP_SERVER);
    } else {
      let apiUrl =
        'https://' + window.location.host.replace('checkout', 'api') + '/api/';
      this.$store.commit('SET_API_URL', apiUrl);
    }
    let username =
      this.$route.name === 'totem' || this.$route.name === 'natal-luz'
        ? '31821'
        : 'checkout@checkout';
    let password =
      this.$route.name === 'totem' || this.$route.name === 'natal-luz'
        ? '908070'
        : '123456';
    this.$store.dispatch('login', {
      username: username,
      password: password,
    });
    if (this.$route.name === 'totem') {
      localStorage.removeItem('checkoutState');
    }
    if (this.$route.name === 'natal-luz') {
      this.$store
        .dispatch('printStatus')
        .then(resp => {
          if (resp.data && !resp.data.paperStatus) this.dialogPrint = true;
        })
        .catch(e => {
          if (e) this.dialogPrint = true;
        });
    }
    this.$store.commit('SET_CREATE_ORDER_IN_PROGRESS', false);

    this.$store.dispatch('getStoreConfigs');

    this.startTimerScreenView();
  },
  methods: {
    openAdminModal() {
      this.numberClicks += 1;
      if (this.numberClicks === 3) this.$store.dispatch('openAdminTerminal');
      if (this.numberClicks === 1)
        setTimeout(() => {
          this.numberClicks = 0;
        }, 1500);
    },
    riskField(ht) {
      var store_domain = 'blueticket.com.br';
      var session_id = ht;
      var url =
        ('https:' == document.location.protocol ? 'https://' : 'http://') +
        'beacon.riskified.com?shop=' +
        store_domain +
        '&sid=' +
        session_id;
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = url;
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    },
    startTimerScreenView() {
      setInterval(() => {
        if (!document.hidden)
          this.$store.commit('SET_SCREEN_TIME_ON', this.screenTimeOn + 1);
      }, 1000);
    },
  },
};
</script>

<style lang="stylus">
@import '~@/assets/_app.styl';
.button-totem-adm {
  position: fixed;
  z-index: 999;
  right: 15px;
  top: 15px;
}
.button-totem-adm .v-btn {
  box-shadow: none !important;
  cursor: default
}
</style>
